<template>
  <v-container fluid>
    <h2 class="mt-5 mb-8">{{$t('task_assignment')}}</h2>
    <v-card>
      <v-tabs background-color="white" color="primary" left @change="changeActiveTab($event)">
        <v-tab>{{$t('category')}}</v-tab>
        <v-tab>{{$t('report')}}</v-tab>
        <v-tab-item>
          <v-container fluid>
            <Category v-if="tabActive == 0"></Category>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container fluid>
            <Report v-if="tabActive == 1"></Report>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
// import axios from "axios";
import Category from "./components/Category";
import Report from "./components/Report";
export default {
  name: "task",
  data() {
    return {
      tabActive: 0
    };
  },
  methods: {
    changeActiveTab(e) {
      this.tabActive = e
    }
  },
  created() {},
  components: {
    Category,
    Report,
  }
};
</script>
